<app-card class="mb-3">
  <div class="d-flex align-items-center uppercase-m semibold mb6">
    <i class="mr6 icon icon--question"></i>
    <span> {{ title() | translate }} </span>
  </div>
  <div class="mt4">
    <ng-content></ng-content>
  </div>
</app-card>
